import TenantSelector from './components/tenant/TenantSelector';
export default TenantSelector;
